import {classes} from './common-classes.st.css';

export const CommonClasses = {
    /** @deprecated use cssEllipsis() instead */
    ellipsis: classes.ellipsis,
    /** @deprecated use Button component instead */
    button: classes.button,
    positioned: classes.positioned,
    hitArea: classes.hitArea,
    hitArea40: classes.hitArea40,
    hideScrollbar: classes.hideScrollbar,
    noWrap: classes.noWrap,
    /** @deprecated use ScrollView instead */
    verticalScrolling: classes.verticalScrolling,
    noUserSelect: classes.noUserSelect,
    /** @deprecated use cssUserSelectableText() instead */
    userSelectText: classes.userSelectText,
    removeNumericInputDecorators: classes.removeNumericInputDecorators,
    /** @deprecated use cssCenterInlineContent instead */
    centerInlineContent: classes.centerInlineContent,
    absoluteStretchInOffsetParent: {
        verticallyAndHorizontally: classes.absoluteStretchInOffsetParentVerticallyAndHorizontally,
        vertically: classes.absoluteStretchInOffsetParentVertically,
        horizontally: classes.absoluteStretchInOffsetParentHorizontally,
    },
    lineClamp: (lines: 2 | 3 | 4 | 8) => {
        switch (lines) {
            case 2: return classes.lineClamp2;
            case 3: return classes.lineClamp3;
            case 4: return classes.lineClamp4;
            case 8: return classes.lineClamp8;
        }
    },
    /** @deprecated use cssCollapsedWhenEmpty() instead */
    collapsedWhenEmpty: classes.collapsedWhenEmpty,
    /** @deprecated use cssOverlay() instead */
    overlay: classes.overlay,
    noPointerEvents: classes.noPointerEvents,
};
